import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Eksternal styling
import styles from './styles';

// Material UI component
import {
  withStyles,
  Grid,
  Typography,
  Button,
  Snackbar
} from '@material-ui/core';

// Shared Component
import Paper from '../Paper';

//Helper
import { isKasbon, rupiahFormat } from 'helpers/Utility';
import CustomDrawer from 'components/CustomDrawer';
import TransactionDetail from 'components/TransactionDetail';
import { SCHEME_CODE_KASBON } from 'common/constants';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { CheckCircle } from '@material-ui/icons';
const TITLE_DASHBORAD_PINANG = 'Cicilan Berikutnya';
const TITLE_DUE_DATE = 'Tagihan Saat ini';
const TITLE_DASHBORAD_KASBON = 'Sisa Tagihan Flexi Payday';
const TITLE_WRITE_OF = 'Tunggakan Pinjaman';

const DisbursementPanel = ({
  classes,
  amount,
  isLate,
  isPaymentAllowed,
  repaymentHandler,
  schemeCode,
  totalOutstandingAmount,
  chargeOfFlag,
  totalOutstandingPriAmount,
  overdueInstallmentInterest,
  overdueInstallmentPenality,
  dueDatePanel,
  arrowHandler,
  currentInstallement,
  totalInstallement,
  nik,
  name,
  lateDaysMonths,
  pendingInstallement,
  isNowDueDate,
  isSuplesiOnProgress
}) => {
  let rootClass;

  if (isKasbon(schemeCode)) {
    rootClass = classes.rootKasbon;
  } else if (chargeOfFlag === 'Y') {
    rootClass = classes.rootWoCard;
  } else {
    rootClass = classes.rootCicil;
  }

  const rootClassName = classNames(classes.isCicil, rootClass);
  const [drawer, setDrawer] = React.useState(false);
  const [totalAmountCopied, setTotalAmountCopied] = React.useState(false);
  const [woRemarksCopied, setWoRemarksCopied] = React.useState(false);
  const [accountNumberCopied, setAccountNumberCopied] = React.useState(false);
  const [countDisbaleConfirmation, setCountDisbaleConfirmation] =
    React.useState(
      Number(localStorage.getItem('countDisbaleConfirmation')) || 0
    );
  const [isDisableConfirmation, setIsDisableConfirmation] =
    React.useState(false);
  const [countOfLate, setCountOfLate] = React.useState(0);

  const today = new Date().toLocaleDateString('id-ID');

  React.useEffect(() => {
    const { months, days } = lateDaysMonths;

    if (!isLate || pendingInstallement == 0) return;

    if (months > 0) {
      setCountOfLate(Math.min(months, pendingInstallement));
      return;
    }

    if (days > 0) {
      setCountOfLate(1);
    }
  }, [lateDaysMonths, pendingInstallement]);

  React.useEffect(() => {
    const savedDate = localStorage.getItem('dateWriteOff');

    if (today !== savedDate) {
      localStorage.setItem('dateWriteOff', today);
      localStorage.setItem('countDisbaleConfirmation', '3');
      setCountDisbaleConfirmation(3);

      setIsDisableConfirmation(false);
      return;
    }

    if (countDisbaleConfirmation === 0) {
      setIsDisableConfirmation(true);
    }
  }, [today, countDisbaleConfirmation]);

  const onCloseSnackBar = () => {
    setTotalAmountCopied(false);
    setWoRemarksCopied(false);
    setAccountNumberCopied(false);
  };

  const getTitleCardLoanActive = () => {
    if (isKasbon(schemeCode)) {
      return TITLE_DASHBORAD_KASBON;
    } else if (chargeOfFlag === 'Y') {
      return TITLE_WRITE_OF;
    } else {
      if (chargeOfFlag === 'Y') return TITLE_WRITE_OF;
      else if (isLate || isNowDueDate) return TITLE_DUE_DATE;
      else return TITLE_DASHBORAD_PINANG;
    }
  };

  const writeOffConfirmPayment = (nama, nik) => {
    if (countDisbaleConfirmation > 0) {
      const count = countDisbaleConfirmation - 1;
      localStorage.setItem('countDisbaleConfirmation', count);

      setCountDisbaleConfirmation(prev => prev - 1);
    }

    const message = `Hai, Tim Pinang Flexi!
Saya ${nama} (${nik}), berhasil bayar pinjaman. Terima kasih😊`;
    const encodedMessage = encodeURIComponent(message);

    window.location.href = `https://wa.me/6281210000494?text=${encodedMessage}`;
  };

  const handleCopyRemarks = () => {
    navigator.clipboard.writeText(`${nik || 'WO_NIK'}`);
    setWoRemarksCopied(true);
  };

  const handleCopyAccountNumber = () => {
    navigator.clipboard.writeText('020601012174304');
    setAccountNumberCopied(true);
  };

  return (
    <>
      <Paper className={rootClassName} elevation={0} squared={false}>
        <Grid container direction="column" spacing={1}>
          <Grid container direction="row" item justify="space-between">
            <Grid item>
              <Typography className={classes.whiteText} variant="h6">
                {getTitleCardLoanActive()}
              </Typography>
            </Grid>
          </Grid>
          <Grid alignItems="center" container direction="row" item spacing={1}>
            <Grid item>
              <Typography className={classes.whiteText} variant="h3">
                Rp {rupiahFormat.format(amount)}
              </Typography>
            </Grid>
            <Grid item>
              <button
                onClick={() => {
                  navigator.clipboard.writeText(amount);
                  setTotalAmountCopied(true);
                }}
                style={{
                  background: 'transparent',
                  border: 'none',
                  padding: 0,
                  margin: 0,
                  cursor: 'pointer'
                }}
                type="button"
              >
                <img
                  alt="clipboard"
                  className={classes.copiedIcon}
                  src="/images/assets/copy-white.svg"
                />
              </button>
            </Grid>
          </Grid>
          {chargeOfFlag !== 'Y' && (
            <Grid
              alignItems="center"
              container
              direction="row"
              justify="space-between"
              style={{ marginTop: '4px', color: 'white' }}
            >
              <Grid className={classes.autodebetGrid} item>
                {isLate || isNowDueDate ? (
                  <Typography
                    className={classes.autodebetTypo}
                    variant="caption"
                  >
                    Jatuh Tempo {dueDatePanel}
                  </Typography>
                ) : (
                  <Typography
                    className={classes.autodebetTypo}
                    variant="caption"
                  >
                    Autodebet {dueDatePanel}
                  </Typography>
                )}
              </Grid>
              <Grid className={classes.rincianGrid} item>
                <Button onClick={arrowHandler}>
                  <Typography className={classes.rincianTypo} variant="caption">
                    Rincian
                  </Typography>
                </Button>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Paper>

      {schemeCode !== SCHEME_CODE_KASBON && chargeOfFlag !== 'Y' && (
        <Paper className={classes.root2} elevation={0} squared={false}>
          <div className={classes.container}>
            <div className={classes.progressSegment}>
              {[...Array(currentInstallement)].map(x => (
                <div className={classes.itemColor} key={x} />
              ))}
              {[...Array(countOfLate)].map(x => (
                <div className={classes.itemColorRed} key={x} />
              ))}
              {[...Array(Math.max(pendingInstallement - countOfLate, 0))].map(
                x => (
                  <div className={classes.item} key={x} />
                )
              )}
            </div>
          </div>
          <Grid container direction="column">
            <Grid className={classes.installmentInformation} item>
              <Typography variant="caption">
                {currentInstallement} dari {totalInstallement} cicilan
              </Typography>
            </Grid>
          </Grid>
          <Grid container direction="column">
            <Grid item>
              <Button
                className={classes.payButton}
                disabled={isPaymentAllowed === 'N' || isSuplesiOnProgress}
                fullWidth
                onClick={repaymentHandler}
                variant="outlined"
              >
                Bayar Lunas Pinjaman
              </Button>
            </Grid>
          </Grid>
        </Paper>
      )}

      {chargeOfFlag === 'Y' && (
        <>
          <Paper
            className={classes.redBoxWriteOff}
            elevation={0}
            squared={false}
          >
            <Grid container direction="column" spacing={1}>
              <Grid container direction="column" item>
                <Grid item>
                  <Grid container direction="row" spacing={1}>
                    <Grid item>
                      <img
                        alt="warning"
                        src="images/assets/warning_write_off.svg"
                      />
                    </Grid>
                    <Grid item>
                      <Typography align="left" variant="h5">
                        Segera lakukan pelunasan pinjaman
                      </Typography>
                    </Grid>
                  </Grid>

                  <Typography align="left" variant="h6">
                    Ikuti petunjuk di bawah ini untuk melunasi pinjamanmu:
                    <div className={classes.guideList}>
                      <ul>
                        <li>
                          Transfer dengan masukkan kode {nik || 'WO_NIK'}
                          <button
                            onClick={handleCopyRemarks}
                            style={{
                              background: 'transparent',
                              border: 'none',
                              padding: 0,
                              margin: 0,
                              cursor: 'pointer'
                            }}
                            type="button"
                          >
                            <img
                              alt="clipboard"
                              className={classes.copiedRemarksIcon}
                              src="/images/assets/copy.svg"
                            />
                          </button>
                        </li>
                        <li>
                          Masukkan nominal pembayaran sesuai tagihan pinjaman
                        </li>
                        <li>Terakhir, konfirmasi pembayaran</li>
                      </ul>
                    </div>
                  </Typography>
                </Grid>
              </Grid>
              <Grid
                className={classes.boxWhite}
                container
                direction="row"
                justify="space-between"
              >
                <Grid item>
                  <Typography variant="h6">Bank BRI</Typography>
                </Grid>
                <Grid item>
                  <Typography align="left" variant="h5">
                    <span>
                      {'0206-0101-2174-304'}
                      <button
                        onClick={handleCopyAccountNumber}
                        style={{
                          background: 'transparent',
                          border: 'none',
                          padding: 0,
                          margin: 0,
                          cursor: 'pointer'
                        }}
                        type="button"
                      >
                        <img
                          alt="clipboard"
                          className={classes.copiedBankIcon}
                          src="/images/assets/copy.svg"
                        />
                      </button>
                    </span>
                  </Typography>
                </Grid>
              </Grid>
              <Grid
                className={classes.boxWhite}
                container
                direction="column"
                spacing={1}
              >
                <Grid container direction="row" item justify="space-between">
                  <Grid item xs={8}>
                    <Typography align="left" variant="h6">
                      Pokok Pinjaman
                    </Typography>
                  </Grid>
                  <Grid item xs={1}>
                    <Typography align="left" variant="h6">
                      Rp
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <Typography align="right" variant="h6">
                      {rupiahFormat.format(totalOutstandingPriAmount)}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container direction="row" item justify="space-between">
                  <Grid item xs={8}>
                    <Typography align="left" variant="h6">
                      Bunga
                    </Typography>
                  </Grid>
                  <Grid item xs={1}>
                    <Typography align="left" variant="h6">
                      Rp
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <Typography align="right" variant="h6">
                      {rupiahFormat.format(overdueInstallmentInterest)}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container direction="row" item justify="space-between">
                  <Grid item xs={8}>
                    <Typography align="left" variant="h6">
                      Denda
                    </Typography>
                  </Grid>
                  <Grid item xs={1}>
                    <Typography align="left" variant="h6">
                      Rp
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <Typography align="right" variant="h6">
                      {rupiahFormat.format(overdueInstallmentPenality)}
                    </Typography>
                  </Grid>
                </Grid>
                <hr />
                <Grid
                  className={classes.boxTotal}
                  container
                  direction="row"
                  item
                  justify="space-between"
                >
                  <Grid item xs={8}>
                    <Typography align="left" variant="h6">
                      Total
                    </Typography>
                  </Grid>
                  <Grid item xs={1}>
                    <Typography align="left" variant="h5">
                      Rp
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <Typography align="right" variant="h5">
                      {rupiahFormat.format(totalOutstandingAmount)}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
          <Grid
            className={classes.rootPaymentConfirm}
            container
            direction="column"
          >
            <Grid item>
              <Button
                color="primary"
                disabled={isDisableConfirmation}
                fullWidth
                onClick={() =>
                  writeOffConfirmPayment(name || 'Nama', nik || 'NIK')
                }
                variant="contained"
              >
                Konfirmasi Pembayaran
              </Button>
            </Grid>
            <Grid
              container
              direction="column"
              item
              spacing={2}
              style={{ marginTop: '10px' }}
            >
              <Grid item>
                <Typography variant="caption">
                  * Klik tombol diatas untuk melakukan Konfirmasi Pembayaran
                  melalui whatsApp dengan melampirkan bukti transfer
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="caption">
                  ** Untuk keperluan verifikasi pembayaran maka tim Sapa Raya
                  akan meminta data-data yang diperlukan
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
      <CustomDrawer
        closeHandler={() => setDrawer('')}
        drawer={drawer}
        setDrawer={setDrawer}
      >
        <TransactionDetail onSetDrawer={setDrawer} />
      </CustomDrawer>
      <Snackbar
        ContentProps={{
          className: classes.snackbarCopiedStyle
        }}
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            onClick={onCloseSnackBar}
            size="small"
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        }
        autoHideDuration={2000}
        //   bodyStyle={{ backgroundColor: 'teal', color: 'coral' }}
        message={
          <span className={classes.snackbarCopiedStyleMessage}>
            <CheckCircle />
            <Typography className={classes.snackCopiedText} variant="caption">
              {totalAmountCopied && 'Total tunggakan pinjaman berhasil disalin'}
              {woRemarksCopied && 'Kode berhasil disalin'}
              {accountNumberCopied && 'Nomor rekening berhasil disalin'}
            </Typography>
          </span>
        }
        onClose={onCloseSnackBar}
        open={totalAmountCopied || woRemarksCopied || accountNumberCopied}
      />
    </>
  );
};

DisbursementPanel.propTypes = {
  amount: PropTypes.number,
  arrowHandler: PropTypes.func,
  classes: PropTypes.object.isRequired,
  currentInstallement: PropTypes.number,
  dueDatePanel: PropTypes.string,
  endDate: PropTypes.string,
  isLate: PropTypes.bool,
  isSuplesiOnProgress: PropTypes.bool,
  loanNumber: PropTypes.string,
  name: PropTypes.string,
  overdueDays: PropTypes.string,
  pendingInstallement: PropTypes.number,
  repaymentHandler: PropTypes.func,
  totalInstallement: PropTypes.number,
  lateDaysMonths: PropTypes.shape({
    months: PropTypes.number,
    days: PropTypes.number
  }),
  isNowDueDate: PropTypes.bool
};

DisbursementPanel.defaultProps = {
  isLate: false
};

export default withStyles(styles)(DisbursementPanel);
